import React from "react";

export const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="179"
    height="369"
    viewBox="0 0 179 369"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.04199 4.25195C16.4767 8.33769 28.4187 13.8767 40.1629 19.7011C82.4363 40.6661 101.254 55.735 134.5 90.4998C152.391 109.208 166.2 134.671 170.478 161.5C175.745 194.524 176.215 240.851 165 272C151.638 309.111 144 317.5 116.775 350.02C112.207 354.114 100.805 365.235 100.844 359.005C100.862 356.142 103.499 352.156 104.017 349.257C105.72 339.737 106.362 330.056 108.136 320.533C110.284 309.002 110.64 311.525 107.609 320.96C103.456 333.892 98.277 347.508 97.6964 361.268C97.4623 366.817 107.582 363.1 110.288 362.548C127.467 359.042 144.426 357.146 161.876 355.891"
      stroke="#EEDAFF"
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);
